<template>

  <div>
    <div class="container">
      <h1 class="title text-center pb-3 mb-5">Creating your Harrods Rewards account</h1>
      <div class="d-flex justify-content-center">
        <span v-if="showLoader" class="spinner-border gold-spinner" role="status" aria-hidden="true" label="Loading..."></span>

        <!--<img class="harrodsLogo mt-3" src="@/assets/gold.svg" placeholder="Loading">-->
      </div>
      <div :style="{ display: displayNotification }">
        <ErrorMessage class="mb-4 mb-lg-5" :errorNotification="errorNotification" />
      </div>
      <p class="text text-center mt-5">Once your account has been registered, you can start using your digital Rewards
        card in-store to collect and redeem points and access promotional discounts</p>
    </div>
  </div>
</template>

<script setup>
    import { ref, onMounted, inject, computed } from 'vue'
    import { useRouter } from 'vue-router'
    import digitalApi from '@/services/DigitalApiClient.js'
    import ErrorMessage from '@/components/ErrorMessage.vue'
    import { useStore } from 'vuex'
    const store = useStore()
    const newUser = computed(() => store.state?.register?.newUser)

    // State
    const errorNotification = ref('')
    const displayNotification = ref('none')
    const showLoader = ref(true)

    // Router and global properties
    const router = useRouter()
    const isMyBeauty = inject('isMyBeauty', false)
    const gtm = inject('gtm', null) // If you provide GTM via provide/inject

    // Methods
    function processSignUpTracking() {
        if (isMyBeauty && gtm) {
            gtm.trackEvent({
                event: 'sign_up',
                method: isMyBeauty ? 'MyBeauty' : 'Rewards'
            })
        }
    }

    function processErrorTracking(error) {
        if (gtm) {
            gtm.trackEvent({
                event: 'sign_up_error',
                method: isMyBeauty ? 'MyBeauty' : 'Rewards',
                error
            })
        }
    }

// Register user on mount
  onMounted(async () => {
      try {
      const result = await digitalApi.registerUser(newUser?.value)
        showLoader.value = false

        if (result.Status === 2) {
          if (result.UIStatus === "2") {
            displayNotification.value = 'block';
            errorNotification.value = `Something went wrong. Please <a href='/en-gb/${isMyBeauty ? 'mybeauty/' : ''}sign-in'><span style='text-decoration: underline; color: #ff2a2a;'>Sign In</span></a> or <a href='/en-gb/${isMyBeauty ? 'mybeauty/' : ''}sign-in'><span style='text-decoration: underline; color: #ff2a2a;'>Reset your password</span></a>`;
            processErrorTracking(result.Status);
          }
          else {
            processSignUpTracking();

            // Store OAT in Vuex before navigation
            store.commit('setOAT', result.OAT);
            router.push({ name: 'DownloadAfterRegister' });
            //success
          }
        }
        else if (result.Status === 202) {
          displayNotification.value = 'block';
          errorNotification.value = 'Sorry, we were unable to register your Loyalty Rewards Card, please contact customer services on +44 (0)20 7730 1234 who will help you resolve this issue.';
          processErrorTracking(result.Status);
        }
        else if (result.Status === 417 || result.Status === 420) {
          displayNotification.value = 'block';
          errorNotification.value = 'There was a problem registering your account. Please try again or call our Customer Service team on +44 (0)20 7730 1234';
          processErrorTracking(result.Status);
        }
        else if (result.Message) {
          router.push({ name: 'GetRewardsRegister', params: { errorMsg: result.Message } });
        }
        else if (result.Status === 400 || result.Status === 4) {
          if (result.UIStatus === "15") {
            displayNotification.value = 'block';
              errorNotification.value = "There was a problem registering your account. Please contact our Chinese Customer Service Team on <a href='tel: +86 21 6154 6680'>+86 21 6154 6680.</a>";
            processErrorTracking(result.UIStatus);
          } else {
              displayNotification.value = 'block';
              errorNotification.value = 'There was a problem registering your account. Please check your email address & Rewards card number and try again or call our Customer Service team on +44 (0)20 7730 1234';
            processErrorTracking(result.UIStatus);
          }
        }
        else if (result.Status === 100) {
            displayNotification.value = 'block';
            errorNotification.value = 'Staff Account';
          processErrorTracking(result.Status);
        }
        else if (result.Status === 300) {
            displayNotification.value = 'block';
            errorNotification.value = `Something went wrong. Please <a href='/en-gb/${isMyBeauty ? 'mybeauty/' : ''}sign-in'><span style='text-decoration: underline; color: #ff2a2a;'>Sign In</span></a> or <a href='/en-gb/${isMyBeauty ? 'mybeauty/' : ''}sign-in'><span style='text-decoration: underline; color: #ff2a2a;'>Reset your password</span></a>`;
          processErrorTracking(result.Status);
        }
        else {
            displayNotification.value = 'block';
            errorNotification.value = 'There was a problem registering your account. Please check your registration form and try again or call our Customer Service team on +44 (0)20 7730 1234';
          processErrorTracking(result.Status);
        }
      } 
    catch (error) {
      console.log(error)
      processErrorTracking(error);
      showLoader.value = false;
        displayNotification.value = 'block';
        errorNotification.value = 'We’re sorry that didn’t work. Our engineers are currently working on the issue. Please try again later. ' + error.response.status != null ? '[ref: ' + error.response.status + ']' : '';

      //this.$appInsights.trackException({exception: error});
    }
  })
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
  color: #ff2a2a;
}
</style>
